import React from 'react';
import { Icon } from '@blueprintjs/core';
import type { TestimonialCardProps } from '../../types';
import './TestimonialCard.scss';

const TestimonialCard: React.FC<TestimonialCardProps> = ({ testimonial }) => {
  return (
    <article className="testimonial-card">
      <div className="testimonial-card__quote-icon">
        <Icon icon="citation" size={24} />
      </div>
      <blockquote className="testimonial-card__quote">
        "{testimonial.quote}"
      </blockquote>
      <div className="testimonial-card__author">
        <div className="testimonial-card__avatar">
          {testimonial.name.charAt(0)}
        </div>
        <div className="testimonial-card__info">
          <cite className="testimonial-card__name">{testimonial.name}</cite>
          {testimonial.condition && (
            <span className="testimonial-card__condition">
              Living Benefits Recipient - {testimonial.condition}
            </span>
          )}
        </div>
      </div>
    </article>
  );
};

export default TestimonialCard;
